import template from './exploreHeaderNg1.jade';
import userGroupsModalTemplate from './userGroupsModal.jade';
import 'angular-modal-service';

class ExploreHeaderComponentNg1Controller {
  constructor($state, ModalService) {
    this.ModalService = ModalService;
    this.$state = $state;
    this.isactiondropdownactive = false;
    this.isModalOpen = false;
  }

  showUserGroupsModal() {
    this.isModalOpen = true;
    this.ModalService.showModal({
      template: userGroupsModalTemplate(),
      controllerAs: 'vm',
      controller: 'UserGroupsModalController',
      inputs: {
        userGroup: {}
      }
    }).then((modal) => {
      modal.close.then((userGroup) => {
        this.isModalOpen = false;
        userGroup && userGroup.id && this.$state.go('app.explore.show.existing', {groupId: userGroup.id});
      });
    });
  }

  actiondropdownclicked() {
    this.isactiondropdownactive = !this.isactiondropdownactive;
  }
}

let ExploreHeaderComponentNg1Component = {
  template: () => { return template },
  controller: ExploreHeaderComponentNg1Controller,
  controllerAs: 'vm',
  bindings: {
    game: "=?",
    areFiltersModified: "=",
    groupId: "=",
    saveNewUserGroup: "&",
    updateUserGroup: "&",
    saveUserGroupAs: "&"
  }
};

export default angular.module('app.components.explore.header', [])
  .component('exploreHeaderNg1', ExploreHeaderComponentNg1Component);


/** WEBPACK FOOTER **
 ** ./src/components/explore/exploreHeader.ng1.js
 **/